(function() {
    const FEE_VARIANT_ID = 48608901759218;
    let isProcessing = false;

    async function syncCustomFee() {
        if (isProcessing) return;
        isProcessing = true;

        try {
            const response = await fetch('/cart.js', { cache: 'no-store' });
            const cart = await response.json();
            
            let targetQty = 0;
            cart.items.forEach(item => {
                // Count jerseys that have the customization property
                if (item.properties && (item.properties['Customization'] || item.properties['customization'])) {
                    targetQty += item.quantity;
                }
            });

            const feeItem = cart.items.find(i => i.variant_id == FEE_VARIANT_ID);
            const currentFeeQty = feeItem ? feeItem.quantity : 0;

            // Only update if there is a mismatch
            if (targetQty !== currentFeeQty) {
                console.log(`Syncing fee: Changing from ${currentFeeQty} to ${targetQty}`);
                
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates: { [FEE_VARIANT_ID]: targetQty } })
                });
                
                // Reload the page to show the user the corrected totals and fee quantity
                window.location.reload();
            }
        } catch (e) {
            console.error("Fee Sync Error:", e);
        } finally {
            isProcessing = false;
        }
    }

    // --- TRIGGERS ---

    // 1. Initial check on page load
    document.addEventListener('DOMContentLoaded', syncCustomFee);

    // 2. The "Overhead" Listener: Detects any AJAX cart changes
    // This catches when the theme's own JS updates a quantity
    const originalFetch = window.fetch;
    window.fetch = function() {
        return originalFetch.apply(this, arguments).then(async (response) => {
            if (response.url.includes('/cart/add') || 
                response.url.includes('/cart/change') || 
                response.url.includes('/cart/update') || 
                response.url.includes('/cart/clear')) {
                
                // Give the theme's animation a moment to finish, then sync
                setTimeout(syncCustomFee, 1000);
            }
            return response;
        });
    };

    // 3. Backup: Watch for clicks on common quantity/remove buttons
    document.addEventListener('click', function(e) {
        if (e.target.closest('.cart__qty-button') || 
            e.target.closest('.cart__remove') || 
            e.target.closest('[data-cart-remove]')) {
            setTimeout(syncCustomFee, 1500);
        }
    });

})();